<script>
import LocalAddInfo from "@/pages/register/LocalAddInfo.vue";
import MyNotifyDialog from "@/components/MyNotifyDialog.vue";

export default {
  name: "IdCardRegister",
  components: {MyNotifyDialog, LocalAddInfo},

  data() {
    return {
      title: "身份证登记",
      step: 3,

      notify: {title: "", show: false, success: false, msg: "",},
      visitor: {}

    }
  }, // end data

  mounted() {
    console.log("IdCardRegister mounted")
    window.addEventListener('idCardCheckEvent', this.handleInputFromJava)
    let baiduFaceKey = this.JavaBaseInfo.getBaseInfo("Setting.BaiduFaceKey")
    let initStatus = this.JavaBaseInfo.getFaceSdkInitStatus()
    let initStatusMsg =this.JavaBaseInfo.getFaceSdkErrorMsg()
    if (initStatus !== 0) {
      let msgNoKey = "没有设置算法key,无法人证核验"
      let msgHasKey = "秘钥激活失败，原因：" + initStatusMsg + "，请确认当前key是否正确，以及输入后是否重启app，如果确认key失效，请输入新key并重启app"
      let msg = baiduFaceKey ? msgHasKey : msgNoKey
      this.$alert(msg, '提示', {
        confirmButtonText: '确定',
      }).then(() => {
        this.$router.back()
      }).catch(() => {
        this.$router.back()
      });
    } else {
      try {
        this.IdCardCheck.startCheckIdCard()
      } catch (e) {
        console.log("IdCardCheck.startCheckIdCard() error")
      }
    }

  },

  destroyed() {
    window.removeEventListener('idCardCheckEvent', this.handleInputFromJava)

  },

  methods: {

    check() {
      this.step = 3
      // this.doOnIdCardCheckSuccess("张三", "1234567890")
      this.doOnIdCardCheckFalse()
    },

    handleInputFromJava(event) {
      const param = JSON.parse(event.detail)
      if (param.isSuccess) {
        this.$message.success("人证比对成功")
        const name = param.name
        const idCardNo = param.idCardNo
        const score = param.score
        this.doOnIdCardCheckSuccess(name, idCardNo, score)
      } else {
        this.doOnIdCardCheckFalse()
      }
    },

    doOnIdCardCheckSuccess(name, idCardNo, score) {
      this.visitor = {name: name, idCardNo: idCardNo, score: score}
      this.$route.params.visitor = {name: name, idCardNo: idCardNo, score: score}
      this.step = 3
    },

    doOnIdCardCheckFalse() {
      this.$message.error("人证比对失败")
      this.$router.back()
    },

    onNotifyDialogClose() {
      this.notify.show = false
      this.$router.back()
      this.$router.back()
    }

  },

}
</script>

<template>
  <div class="page-box">


    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title"
                      @dialogClose="onNotifyDialogClose"></my-notify-dialog>


    <div v-if="step === 2">
      <el-button @click="check">认证核验</el-button>
    </div>

    <LocalAddInfo v-if="step === 3" :idCardvisitor="visitor"></LocalAddInfo>
  </div>
</template>

<style scoped lang="less">
.page-box {

}


</style>
